module.exports = __webpack_public_path__ + "static/media/DwnldLoader.6929d1c8.svg";